import moment from 'moment';
import 'moment/locale/zh-cn';

//订单状态（1-未出库 2-部分出库 3-已出库）
export function orderStateFilter(state) {
  switch (state) {
    case 1:
      return "未出库";
    case 2:
      return "部分出库";
    case 3:
      return "已出库";
    default:
      return "未知"
  }
}


//客户类型（0-个人 1-公司）
export function customerTypeFilter(state) {
  switch (state) {
    case 0:
      return "个人";
    case 1:
      return "公司";
    default:
      return "未知"
  }
}

//电池产品类型(1:电池包,2:电池模块,3:电池单体)
export function productTypeFilter(type) {
  switch (type) {
    case 1:
      return "电池包";
    case 2:
      return "电池模块";
    case 3:
      return "电池单体";
    default:
      return "未知"
  }
}

//电池产品类型(1:普票,2:专票)
export function invoiceTypeFilter(type) {
  switch (type) {
    case 1:
      return "普票";
    case 2:
      return "专票";
    default:
      return "未知"
  }
}


//状态(1-未生效、2-生效中、3-作废)
export function reportedConfigStatusFilter(status) {
  switch (status) {
    case 1:
      return "未生效";
    case 2:
      return "生效中";
    case 3:
      return "作废";
    default:
      return "未知"
  }
}

//接口类型：
//
// 1-整车报废电池接收接口
// 2-整车报废电池出库接口
// 3-梯次包生产接口
// 4-梯次模块生产接口
// 5-梯次单体生产接口
// 6-编码报废接口
// 7-质量报废接口
// 8-编码入库接口
// 9-质量入库接口
// 10-回收资源接口
export function reportedConfigTypeFilter(type) {
  switch (type) {
    case 1:
      return "整车报废电池接收接口";
    case 2:
      return "整车报废电池接收接口";
    case 3:
      return "梯次包生产接口";
    case 4:
      return "梯次模块生产接口";
    case 5:
      return "梯次单体生产接口";
    case 6:
      return "编码报废接口";
    case 7:
      return "质量报废接口";
    case 8:
      return "编码入库接口";
    case 9:
      return "质量入库接口";
    case 10:
      return "回收资源接口";
    default:
      return "未知"
  }
}

export function reportedStatusFilter(status) {
  switch (status) {
    case 1:
      return "未上报";
    case 2:
      return "上报中";
    case 3:
      return "上报成功";
    case 4:
      return "上报失败";
    default:
      return "未知"
  }
}


export function lnglatFilter(value) {
  if (!value) {
    return 0;
  }
  return value;
}

//A  镍氢电池
// B  磷酸铁锂电池
// C  锰酸锂电池
// D  钴酸锂电池
// E  三元材料电池
// F  超级电容器
// G  钛酸锂电池
// Z  其他
export function barCodeBatteryTypeFilter(type) {
  switch (type) {
    case 'A':
      return "镍氢电池";
    case 'B':
      return "磷酸铁锂电池";
    case 'C':
      return "锰酸锂电池";
    case 'D':
      return "钴酸锂电池";
    case 'E':
      return "三元材料电池";
    case 'F':
      return "超级电容器";
    case 'G':
      return "钛酸锂电池";
    case 'Z':
      return "其他";
    default:
      return type;

  }
}

export function barCodeIsEchelonFilter(status) {
  switch (status) {
    case 1:
      return "是";
    case 2:
      return "否";
    default:
      return status
  }
}


//   {name: "电池包直接梯级利用", value: 1},
//           {name: "电池模块直接梯级利用", value: 2},
//           {name: "电池单体梯级利用", value: 3}]
export function batteryCodeEchelonTypeFilter(type) {
  switch (type) {
    case 1:
      return "电池包直接梯级利用";
    case 2:
      return "电池模块直接梯级利用";
    case 3:
      return "电池单体梯级利用";
    default:
      return type
  }
}

export function categoryStatesFilter(status) {
  switch (status) {
    case 1:
      return "启用";
    case 2:
      return "禁用";
    default:
      return status;

  }
}
export function isCodeFilter(status) {
  switch (status) {
    case "0":
      return "是";
    case "1":
      return "否";
  }
  return status;

}
export function booleanFilter(status) {
  switch (status) {
    case 1:
      return "是";
    case 0:
      return "否";
    case "1":
      return "是";
    case "0":
      return "否";
    case "Y":
      return "是";
    case "N":
      return "否";
    case true:
      return "是";
    case false:
      return "否";
    default:
      return status;

  }
}

export function inverterStateFilter(status) {
  switch (status) {
    case  1:
      return "connect";
    case 0:
      return "disconnect";
    default:
      return status;

  }
}